export interface QuoteDocument {
  name: string;
  link: string;
}
